function getCause(exception) {
  if (typeof exception === 'object' && exception !== null && 'cause' in exception) {
    return exception.cause;
  }
  return null;
}
function getChirpErrorMessage(exception) {
  if (typeof exception === 'object' && exception !== null && 'chirpErrorMessage' in exception && typeof exception.chirpErrorMessage === 'string') {
    return exception.chirpErrorMessage;
  }
  return null;
}
class ApiError {
  constructor(exception) {
    this.exception = exception;
  }
  getMessage() {
    const chirpErrorMessage = getChirpErrorMessage(getCause(getCause(this.exception)));
    if (chirpErrorMessage !== null) {
      return chirpErrorMessage;
    }
    if (this.exception instanceof Error) {
      return this.exception.message;
    }
    if (typeof this.exception === 'string') {
      return this.exception;
    }
    return 'Alarm request failed';
  }
}
export default ApiError;